const mql = window.matchMedia('(min-width: 981px)');
const header = document.getElementById('site-header');
const height = 200;

function handleMediaQuery(e) {
    if (e.matches) {
        document.addEventListener('scroll', function () {
            if (height < window.scrollY) {
                header.classList.add('is-sticky');
            } else {
                header.classList.remove('is-sticky');
            }
        }, { passive: true });
    } else {
        ;
    }
};

if (header) {
    handleMediaQuery(mql);
    mql.addEventListener('change', handleMediaQuery, false);
}